import styled from 'styled-components';

export const StyledVideo = styled.video`
  width: 100%;
  max-width: 600px;
  margin-top: 12px;
`;
